import React, { useContext, useState } from "react";

//main page components
import Form from './itinerary/forms/details';
import Days from './itinerary/days';
import { LoadingButton } from '../../shared/loading-button';
import AbtaBox from "../../shared/abta-box";
import WhyBook from "../../shared/why-book";
//import WhyBookSlider from "../../shared/why-book-slider";
import Packages from "./packages"
import Collapsible from 'react-collapsible';
import { Link } from "@reach/router";

//get the context
import QuoteContext from "../quote-context"

//validations
import {validItineraryForm} from '../validations'

const Itinerary = ({ processForm, hasPackages, defaultPackages, siteId, edit }) => {

	const {navigation, navigationDispatcher, formData} = useContext(QuoteContext);
	
	const [ accomPopupCalled, setAccomPopupCalled ] = useState( false )
	
	const [ tab, setTab ] = useState( 'byo' )
	
	const missingAccom = () => {
		if( accomPopupCalled == false && formData.hotel == false && formData.hotelStandard == false && formData.package == false && formData.superPackage == false ) {
			setAccomPopupCalled( true )
			return true;
		} else {
			return false;
		}
	}
	
	const singleActivity = () => {
		if( siteId == 17 && ( formData.hotel == false && formData.hotelStandard == false ) && formData.activities.length <=  1 ) {
			return true;
		} else {
			return false;
		}
	}
		
	const loadAccomPopup = ( callback ) => {
		navigationDispatcher({
			type: 'OPEN_MODAL',
			modal: './modals/quote/choose-accommodation',
			title: 'Accomodation',
			payload: {
				choose: () => {
					navigationDispatcher({type: "GOTO_STEP", step: 'accommodation', params: { day: 1, isPackage: false } });
				},
				submit: () => {
					nextStep();
				},
				siteId: siteId
			}
		})
		setAccomPopupCalled( true )
	}
	
	const nextStep = () => {
		
		if( navigation.loggedIn ) {
			processForm();
		} else {
			navigationDispatcher({type: "GOTO_STEP", step: "submit", params: { isPackage: false } });

			navigationDispatcher({
				type: 'TRACK_EVENT',
				action: 'event',
				category: 'form-submit',
				name: 'itinerary-submit',
				trigger: 'web-js',
				data:  {
					pax: formData.pax,
					date: formData.date,
					activities: formData.activities.length,
					hotel: formData.hotel,
					hotelStandard: formData.hotelStandard,
					superPackage: formData.superPackage,
					valid: true
				}
			});
		}
	}

	const handleSubmit = () => {

		let errors = validItineraryForm( formData, true ) ;

		if( errors.length == 0 ){
			if( singleActivity() )  {
				navigationDispatcher({
					type: 'OPEN_MODAL',
					modal: './modals/quote/single-activity',
					title: 'Accomodation',
					payload: {
						choose: () => {
							navigationDispatcher({type: "GOTO_STEP", step: 'accommodation', params: { day: 1, isPackage: false } });
						},
						submit: () => {
							nextStep();
						},
						siteId: siteId
					}
				})
			} else {
				if( missingAccom() ) {
					loadAccomPopup()
				} else {
					nextStep()
				}
			}

		} else {
			navigationDispatcher({type: "RAISE_FIELD_ERRORS", errors: errors });
			navigationDispatcher({
				type: 'TRACK_EVENT',
				action: 'error',
				category: 'validation-errors',
				name: 'itinerary-submit',
				trigger: 'web-js',
				data:  errors
			});
		}
	}
	
	const renderView = () => {
		if( edit ) {
			return (
				<EditView 
					navigation={navigation}
					formData={formData} 
					siteId={siteId}
					processForm={processForm}
					tab={tab}
				/> 	
			)
		} else {
			if( siteId == 17 ) {
				return (
					<HenView
						navigation={navigation}
						formData={formData}
						siteId={siteId}
						hasPackages={hasPackages}
						defaultPackages={defaultPackages}
						processForm={processForm}
						tab={tab}
						handleSubmit={handleSubmit}
					/>
				)
			} else {
				return (
					<StagView 
						navigation={navigation}
						formData={formData} 
						siteId={siteId}
						hasPackages={hasPackages}
						defaultPackages={defaultPackages}
						processForm={processForm}
						tab={tab}
						handleSubmit={handleSubmit}
					/> 
				)
			}
		}
	}
	
	return (
		<>
		<div className="full-width-block white pd-t-lrg pd-b-tch-xxlrg pd-b-tab-xxlrg">
			<div className="row no-padding">
				<div className="column">
					<div className="pd-h-tch pd-h-dsk-md">
						<div className="full-width-block white">
							<div className="row no-padding">
								<div className="column three-quarters full-tab">
									<div className="pd-r-dsk-lrg mg-b-tch-lrg">

										{ edit ?
											<Link to="/myaccount" className="align-content vertical center link plain mg-b-sm"><span className="icon icon-chevron-left small left"></span>Quotes</Link>
										: null }

										<h2 className="mg-b-lrg">Your {siteId == 1 ? 'stag' : 'hen'} do details</h2>
										
										<div className="content-block radius mg-b-tch-lrg">
											<Form 
												siteId={siteId}
											/>
										</div>
										
										{renderView()}
		
									</div>
								</div>
							
								<div className="column one-quarter full-tab">
									
									<div className="show-for-large dir-col">
										<WhyBook 
											siteId={siteId}
										/>
									</div>

									<AbtaBox 
										siteId={siteId}
									/>
									
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>	
		</>
	)
}

const StagView = ({ navigation, formData, siteId, hasPackages, defaultPackages,  processForm, tab, handleSubmit }) => {
	return (
		<>
		{ formData.date.length > 1 ? (
			<>
				<h2 className="mg-v-dsk-lrg">Select a stag do</h2>

				<h4>Create your own</h4>
				
				<div className="mg-b-lrg">
					<Days 
						siteId={siteId}
					/>
				</div>
					
				{ hasPackages ? (
					<div className="collapsible-panel">
						<Collapsible trigger="Or choose a pre built package">
						
						<Packages
							packages={defaultPackages}
							processForm={processForm}
						/>
						
					</Collapsible>
					</div>
					
				) : null }			
			</>
		) : null }

		
		{ tab != 'packages' ? (
		<LoadingButton
			value={navigation.loggedIn ? 'Get price' : 'Continue'}
			submit={handleSubmit}
			processing={navigation.processing}
			buttonClass={ validItineraryForm( formData, false ) ? 'button primary fill-mob center radius large mg-t' : 'button primary fill-mob center radius large mg-t disabled'}
		/>
		) : null}
		</>
	)
}

const HenView = ({ navigation, formData, siteId, hasPackages, defaultPackages,  processForm, tab, handleSubmit }) => {
	
	// const hasContent = formData.activities.length != 0 || formData.nights != 0;
	// const [ view, setView ] = useState( hasContent ? 'byo' : 'packages' );
	const [ view, setView ] = useState( 'byo' );
	
	return (
		<>
		{ formData.date.length > 1 ? (
			<>
				<h2 className="mg-v-dsk-lrg">Create your hen do</h2>

				
				<div className="align-content vertical center tabs mg-b-lrg">
					<div><a onClick={() => setView('byo')} className={view == 'byo' ? `tab active` : `tab`}>Build your own</a></div>
					<div><a onClick={() => setView('packages')} className={view == 'packages' ? `tab active` : `tab`}>Packages</a></div>
				</div>
				
			
				{ !hasPackages || view == 'byo' ? ( 
						<>
						
						<div className="mg-b-lrg">
							<Days
								siteId={siteId}
							/>
						</div>
						</>
				) : (
				
					<>
						<Packages
							packages={defaultPackages}
							processForm={processForm}
						/>
					</>
				
				)}
			</>
		) : null }

		
		{ tab != 'packages' ? (
		<LoadingButton
			value={navigation.loggedIn ? 'Get price' : 'Continue'}
			submit={handleSubmit}
			processing={navigation.processing}
			buttonClass={ validItineraryForm( formData, false ) ? 'button primary fill-mob center radius large mg-t' : 'button primary fill-mob center radius large mg-t disabled'}
		/>
		) : null}
		</>
	)
}

const EditView = ({ navigation, formData, siteId, processForm, tab }) => {
	return (
		<>
		{ formData.date.length > 1 ? (
			
			<div className="mg-b-lrg mg-t-lrg">
				<Days />
			</div>
		
		) : null }

		
		<LoadingButton
			value="Save Quote"
			submit={processForm}
			processing={navigation.processing}
			buttonClass={ validItineraryForm( formData, false ) ? 'button primary fill-mob center radius large mg-t' : 'button primary fill-mob center radius large mg-t disabled'}
		/>
		</>
	)
}


export default Itinerary;
